<app-navbar></app-navbar>
<main>
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>


@if (stage != 'prod') {
  <div class="version">
    <p>{{stage}} - {{version}} - {{ buildDateTime }}</p>
  </div>
}
